/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BidRequest,
    BlockUserRequest,
    StartAuctionRequest,
    StartAuctionResponse,
} from '../models';

export interface LiveStreamAuctionApiControllerBidRequest {
    liveStreamId: string;
    auctionId: string;
    bidRequest: BidRequest;
}

export interface LiveStreamAuctionApiControllerBlockUserRequest {
    liveStreamId: string;
    auctionId: string;
    blockUserRequest: BlockUserRequest;
}

export interface LiveStreamAuctionApiControllerCancelAuctionRequest {
    liveStreamId: string;
    auctionId: string;
}

export interface LiveStreamAuctionApiControllerFinishAuctionRequest {
    liveStreamId: string;
    auctionId: string;
}

export interface LiveStreamAuctionApiControllerInvalidateBidRequest {
    liveStreamId: string;
    auctionId: string;
    bidId: string;
}

export interface LiveStreamAuctionApiControllerStartAuctionRequest {
    liveStreamId: string;
    startAuctionRequest: StartAuctionRequest;
}

/**
 * 
 */
export class LiveStreamAuctionApi extends runtime.BaseAPI {

    /**
     */
    async liveStreamAuctionApiControllerBidRaw(requestParameters: LiveStreamAuctionApiControllerBidRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerBid.');
        }

        if (requestParameters.auctionId === null || requestParameters.auctionId === undefined) {
            throw new runtime.RequiredError('auctionId','Required parameter requestParameters.auctionId was null or undefined when calling liveStreamAuctionApiControllerBid.');
        }

        if (requestParameters.bidRequest === null || requestParameters.bidRequest === undefined) {
            throw new runtime.RequiredError('bidRequest','Required parameter requestParameters.bidRequest was null or undefined when calling liveStreamAuctionApiControllerBid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/auctions/{auctionId}:bid`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"auctionId"}}`, encodeURIComponent(String(requestParameters.auctionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bidRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerBid(requestParameters: LiveStreamAuctionApiControllerBidRequest): Promise<void> {
        await this.liveStreamAuctionApiControllerBidRaw(requestParameters);
    }

    /**
     */
    async liveStreamAuctionApiControllerBlockUserRaw(requestParameters: LiveStreamAuctionApiControllerBlockUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerBlockUser.');
        }

        if (requestParameters.auctionId === null || requestParameters.auctionId === undefined) {
            throw new runtime.RequiredError('auctionId','Required parameter requestParameters.auctionId was null or undefined when calling liveStreamAuctionApiControllerBlockUser.');
        }

        if (requestParameters.blockUserRequest === null || requestParameters.blockUserRequest === undefined) {
            throw new runtime.RequiredError('blockUserRequest','Required parameter requestParameters.blockUserRequest was null or undefined when calling liveStreamAuctionApiControllerBlockUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/auctions/{auctionId}:block-user`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"auctionId"}}`, encodeURIComponent(String(requestParameters.auctionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.blockUserRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerBlockUser(requestParameters: LiveStreamAuctionApiControllerBlockUserRequest): Promise<void> {
        await this.liveStreamAuctionApiControllerBlockUserRaw(requestParameters);
    }

    /**
     */
    async liveStreamAuctionApiControllerCancelAuctionRaw(requestParameters: LiveStreamAuctionApiControllerCancelAuctionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerCancelAuction.');
        }

        if (requestParameters.auctionId === null || requestParameters.auctionId === undefined) {
            throw new runtime.RequiredError('auctionId','Required parameter requestParameters.auctionId was null or undefined when calling liveStreamAuctionApiControllerCancelAuction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/auctions/{auctionId}:cancel`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"auctionId"}}`, encodeURIComponent(String(requestParameters.auctionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerCancelAuction(requestParameters: LiveStreamAuctionApiControllerCancelAuctionRequest): Promise<void> {
        await this.liveStreamAuctionApiControllerCancelAuctionRaw(requestParameters);
    }

    /**
     */
    async liveStreamAuctionApiControllerFinishAuctionRaw(requestParameters: LiveStreamAuctionApiControllerFinishAuctionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerFinishAuction.');
        }

        if (requestParameters.auctionId === null || requestParameters.auctionId === undefined) {
            throw new runtime.RequiredError('auctionId','Required parameter requestParameters.auctionId was null or undefined when calling liveStreamAuctionApiControllerFinishAuction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/auctions/{auctionId}:finish`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"auctionId"}}`, encodeURIComponent(String(requestParameters.auctionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerFinishAuction(requestParameters: LiveStreamAuctionApiControllerFinishAuctionRequest): Promise<void> {
        await this.liveStreamAuctionApiControllerFinishAuctionRaw(requestParameters);
    }

    /**
     */
    async liveStreamAuctionApiControllerInvalidateBidRaw(requestParameters: LiveStreamAuctionApiControllerInvalidateBidRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerInvalidateBid.');
        }

        if (requestParameters.auctionId === null || requestParameters.auctionId === undefined) {
            throw new runtime.RequiredError('auctionId','Required parameter requestParameters.auctionId was null or undefined when calling liveStreamAuctionApiControllerInvalidateBid.');
        }

        if (requestParameters.bidId === null || requestParameters.bidId === undefined) {
            throw new runtime.RequiredError('bidId','Required parameter requestParameters.bidId was null or undefined when calling liveStreamAuctionApiControllerInvalidateBid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/auctions/{auctionId}/bids/{bidId}:invalidate`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"auctionId"}}`, encodeURIComponent(String(requestParameters.auctionId))).replace(`{${"bidId"}}`, encodeURIComponent(String(requestParameters.bidId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerInvalidateBid(requestParameters: LiveStreamAuctionApiControllerInvalidateBidRequest): Promise<void> {
        await this.liveStreamAuctionApiControllerInvalidateBidRaw(requestParameters);
    }

    /**
     */
    async liveStreamAuctionApiControllerStartAuctionRaw(requestParameters: LiveStreamAuctionApiControllerStartAuctionRequest): Promise<runtime.ApiResponse<StartAuctionResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamAuctionApiControllerStartAuction.');
        }

        if (requestParameters.startAuctionRequest === null || requestParameters.startAuctionRequest === undefined) {
            throw new runtime.RequiredError('startAuctionRequest','Required parameter requestParameters.startAuctionRequest was null or undefined when calling liveStreamAuctionApiControllerStartAuction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:start-auction`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.startAuctionRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamAuctionApiControllerStartAuction(requestParameters: LiveStreamAuctionApiControllerStartAuctionRequest): Promise<StartAuctionResponse> {
        const response = await this.liveStreamAuctionApiControllerStartAuctionRaw(requestParameters);
        return await response.value();
    }

}
